import { render, staticRenderFns } from "./UserSelectionModal.vue?vue&type=template&id=e518e3d6&v-if=widgetReady&"
import script from "./UserSelectionModal.vue?vue&type=script&lang=js&"
export * from "./UserSelectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSelectionModal.vue"
export default component.exports